import PropTypes from 'prop-types';
import React from 'react';
import {compose} from 'redux';
import {
    isEqual as _isEqual,
} from 'lodash';

import {graphql} from 'react-apollo';
import {Authorization} from '@appComponents/Authorization';
import {ENCODING_TARGET} from '@constants/resources';
import {convertToInt} from '@utils/helpers';
import {PRODUCT_SPOTT, SECURITY_PRIVILEGES_READ} from '@constants/variables';
import {GetEncodingTargetsForDistributions} from '@graphql/encodingTarget/query';

import EventsConfigurationCdnConfigurations from '../components/EventsConfigurationCdnConfigurations';
import EventsConfigurationTargets from '../components/EventsConfigurationTargets';


const authorizationEncodingTargetReadObject = {
    [ENCODING_TARGET]: SECURITY_PRIVILEGES_READ,
};

class EventsConfigurationTargetsCdnConfigurationsWrapper extends React.Component {
    static propTypes = {
        DataEventContentTargets: PropTypes.object.isRequired,
        content: PropTypes.object.isRequired,
        eventId: PropTypes.number.isRequired,
        loading: PropTypes.bool,
        Modal: PropTypes.object.isRequired,
        setEncodingTargets: PropTypes.func.isRequired,
        setLoadingEncodingTargets: PropTypes.func.isRequired,
    };

    static defaultProps = {
        loading: false,
    };

    constructor() {
        super();

        this.state = {
            encodingTargets: [],
        };
    }

    componentDidUpdate(prevProps) {
        const {
            DataEventContentTargets: {encodingTargets, loading: loading},
        } = this.props;

        if (!_isEqual(prevProps.DataEventContentTargets.encodingTargets, encodingTargets)) {
            const nextEncodingTargets = encodingTargets || [];

            this.props.setEncodingTargets(nextEncodingTargets, this.props.content.id);
            this.setState({encodingTargets: nextEncodingTargets});
        }

        if (
            prevProps.DataEventContentTargets.loading !== loading
        ) {
            this.props.setLoadingEncodingTargets(loading);
        }
    }

    hasSpottDistribution = (distributions) => (
        0 < distributions.filter((distribution) => (
            parseInt(distribution.product.id, 10) === PRODUCT_SPOTT
        )).length
    );

    render() {
        return (
            <Authorization authorization={authorizationEncodingTargetReadObject}>
                <>
                    {
                        <EventsConfigurationTargets
                            content={this.props.content}
                            encodingTargets={this.state.encodingTargets}
                            eventId={this.props.eventId}
                            loading={this.props.DataEventContentTargets.loading}
                            Modal={this.props.Modal}
                        />
                    }
                    {
                        this.hasSpottDistribution(this.props.content.distributions) && <EventsConfigurationCdnConfigurations
                            distributions={this.props.content.distributions}
                            eventContentId={parseInt(this.props.content.id, 10)}
                            eventId={this.props.eventId}
                        />
                    }
                </>
            </Authorization>
        );
    }
}

export default compose(
    graphql(GetEncodingTargetsForDistributions, {
        options : (props) => {
            const distributions = props.content.distributions.map((d) => convertToInt(d.id));

            return {
                notifyOnNetworkStatusChange: true,
                fetchPolicy : 'network-only',
                variables: {
                    distributions: distributions,
                },
            };
        },
        name: 'DataEventContentTargets',
    })
)(EventsConfigurationTargetsCdnConfigurationsWrapper);
